<div class="root pt-4 margin-content">
  <my-custom-markup-container [content]="homepageContent"></my-custom-markup-container>
</div>

